<script setup lang="ts">
import { formatDecimalAndNumberWithComma } from '@/helpers/numFormats'
import { Sign as SignInterface } from '@/models/sign'
import { useUserStore } from '@/store/user'

interface IProps {
  sign?: SignInterface,
}

const props = withDefaults(defineProps<IProps>(), {
  sign: () => ({}),
})

interface Emit {
}

const emit = defineEmits<Emit>()

const userStore = useUserStore()
</script>

<template>
  <VCardText>
    <VRow>
      <VCol class="d-flex align-center py-0">
        <span>
          Price:
          {{ formatDecimalAndNumberWithComma(sign?.sign_price) }}
        </span>
      </VCol>
    </VRow>
  </VCardText>
</template>

<style lang="scss" scoped>
</style>
